import { Box } from '@material-ui/core';
import Logo from './Logo';
import { toneAlpha } from '../theme/tones';

/**
 * Écran d'amorçage : logo posé sur un fond dégradé animé, avec une barre
 * de progression indéterminée. L'attente devient un moment de marque
 * plutôt qu'un écran vide.
 */
const SlashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000,
      backgroundColor: 'background.default',
      backgroundImage: (theme) => (theme.palette.mode === 'light'
        ? `radial-gradient(900px 480px at 50% 12%, ${toneAlpha('blue', 0.1)}, transparent 62%)`
        : `radial-gradient(900px 480px at 50% 12%, ${toneAlpha('blue', 0.12)}, transparent 62%)`)
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        animation: 'splash-in 0.6s cubic-bezier(0.4, 0, 0.2, 1) both',
        '@keyframes splash-in': {
          from: { opacity: 0, transform: 'translateY(10px) scale(0.98)' },
          to: { opacity: 1, transform: 'none' }
        }
      }}
    >
      <Logo />

      {/* Barre indéterminée : un simple segment qui balaye la piste. */}
      <Box
        sx={{
          position: 'relative',
          width: 168,
          height: 3,
          borderRadius: 999,
          overflow: 'hidden',
          backgroundColor: 'divider',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '42%',
            borderRadius: 999,
            background: (theme) => `linear-gradient(90deg, ${theme.palette.secondary.main} 0%, ${theme.palette.tones.indigo.base} 100%)`,
            animation: 'splash-sweep 1.15s cubic-bezier(0.65, 0, 0.35, 1) infinite'
          },
          '@keyframes splash-sweep': {
            '0%': { transform: 'translateX(-110%)' },
            '100%': { transform: 'translateX(275%)' }
          }
        }}
      />
    </Box>
  </Box>
);

export default SlashScreen;
